import { CatchupAIHubModule } from '@1js/ai-hub-relay-components-loader';
import { AiHubPageUnstyled } from '@office-start/ai-hub-page-component';
import { useLogPageView } from '@office-start/office-home-app-shared';
import React from 'react';
var componentName = 'CatchUpComponent';
var CatchUpComponent = CatchupAIHubModule;
CatchUpComponent.displayName = 'CatchUpComponent';
export var CatchUpPage = function () {
    return (React.createElement(AiHubPageUnstyled, { useLogPageViewHook: useLogPageView, name: "CatchUp", LazyComponent: CatchUpComponent, componentName: componentName }));
};
//# sourceMappingURL=CatchUpPage.js.map